import { individualSurveysDashboardLoader } from '../../../util/dataLoader';
import { HttpRequest } from '../../../util/http';
import { StatusTypesEndpoint } from '../../../util/http/endpoints';
import { userData } from '../../../util/userData';
import {
  ICoachingData,
  ICoachingValue,
  IResolutionStatus,
  IAdvancedActionAlerts,
  IClassicActionAlerts
} from '../../CoachingFormContainer/interfaces';
import { IStatusTypes } from '../../CoachingFormStatus/interfaces';
import {format} from "date-fns";
import {getUserActivityReportPdfExport} from "../../UserActivityReportContainer/pdfExport";

export const getIndividualSurveysData = (filters) => {
  let dateRange = '';
  let lowerLimit = '';
  let upperLimit = '';
  if (filters.dateRange && filters.dateRange !== 'N/A') {
    dateRange = filters.dateRange.split('-');
    lowerLimit = dateRange[0].replace(/\//g, '-');
    upperLimit = dateRange[1].replace(/\//g, '-');
  } else {
    const currentDate = new Date( );
    const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    lowerLimit = firstDayOfMonth.getFullYear().toString() + '-' + (firstDayOfMonth.getMonth() + 1).toString() + '-' + firstDayOfMonth.getDate().toString();
    upperLimit = currentDate.getFullYear().toString() + '-' + (currentDate.getMonth() + 1).toString() + '-' + currentDate.getDate().toString();
  }
  // Convert to UTC before requesting Individual Surveys
  const lowerLimitPieces = lowerLimit.split('-')
  const lowerLimitYear = parseInt(lowerLimitPieces[0], 10)
  const lowerLimitMonth = parseInt(lowerLimitPieces[1], 10) - 1
  const lowerLimitDay = parseInt(lowerLimitPieces[2], 10)
  const utcDateLowerLimit = new Date(lowerLimitYear, lowerLimitMonth, lowerLimitDay, 0, 0, 0)

  lowerLimit = utcDateLowerLimit.toISOString();

  const upperLimitPieces = upperLimit.split('-');
  const upperLimitYear = parseInt(upperLimitPieces[0], 10);
  const upperLimitMonth = parseInt(upperLimitPieces[1], 10) - 1;
  const upperLimitDay = parseInt(upperLimitPieces[2], 10);
  const utcDateUpperLimit = new Date(upperLimitYear, upperLimitMonth, upperLimitDay, 23, 59, 59);
  let formattedDate = format(utcDateUpperLimit, 'yyyy-MM-dd HH:mm:ss');

  upperLimit = formattedDate.toString();

  const readyFilters = {...filters,
     lowerLimit,
     upperLimit,
     allTime: !filters.dateRange || filters.dateRange === 'N/A' ? 1 : 0
  };

  return new Promise<ICoachingData>((resolve) => {
    individualSurveysDashboardLoader.get(readyFilters).then((res: ICoachingData) => {
      resolve(res);
    });
  });
};

export const loadIndividualSurveysStatusTypes = () => {
  return new Promise<IStatusTypes[]>((resolve) => {
    HttpRequest.fetch<IStatusTypes[]>(StatusTypesEndpoint).then(
      (statusTypes) => {
        resolve(statusTypes);
      }
    );
  });
};

export const loadIndividualSurveysStatuses = () => {
  return new Promise<IResolutionStatus[]>((resolve) => {
    HttpRequest.fetch<IResolutionStatus[]>(
      '/scripts/coaching_form/status_get_all'
    ).then((statuses) => resolve(statuses));
  });
};

export const loadActionAlertsAttachedStatus = (
  individualSurveys: ICoachingValue[]
) => {
  return new Promise<any[]>((resolve) => {
    const ids = individualSurveys.reduce((acc, curr) => {
      return acc.concat(curr.id);
    }, []);
    const method = 'POST';
    const data = {
      current_project: userData.getCurrentProject(),
      coachingFormsIds: ids.join(','),
    };
    HttpRequest.fetch<any[]>('/scripts/coaching_forms/get_attached_alerts_status', {
      data,
      method,
    }).then((actionAlertsAttachedStatus) =>
      resolve(actionAlertsAttachedStatus)
    );
  });
};

export const loadAdvancedActionAlertsAccess = () => {
  return new Promise<IAdvancedActionAlerts>((resolve) => {
    HttpRequest.fetch<IAdvancedActionAlerts>(
      '/scripts/coaching_form/enableActionAlerts'
    ).then((res) => resolve(res));
  });
};

export const loadClassicActionAlertsAccess = () => {
  return new Promise<IClassicActionAlerts>((resolve) => {
    HttpRequest.fetch<IClassicActionAlerts>(
      '/scripts/coaching_form/enableClassicActionAlerts'
    ).then((res) => resolve(res));
  });
};
